<template>
    <b-table
        id="devedores"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum devedor encontrado.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.codContribuinte)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Nome <i class="filter" :class="!isEmpty(filtro.nome) || filtro.filtrarNome == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Nome', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            {{ item.nome }}
        </template>
        <template v-slot:head(2)="{ item }">
            Tipo de Devedor <i class="filter" :class="!isEmpty(filtro.tipoContribuinte) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo de Devedor', 'radio', 'Pessoa Física,Pessoa Jurídica', null, $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            {{ item.tipoDevedor }}
        </template>
        <template v-slot:head(3)="{ item }">
            CPF <i class="filter" :class="!isEmpty(filtro.cpf) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CPF', 'mascara', '', '###.###.###-##', $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            {{ item.cpf | cpfCnpj }}
        </template>
        <template v-slot:head(4)="{ item }">
            CNPJ <i class="filter" :class="!isEmpty(filtro.cnpj) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CNPJ', 'mascara', '', '##.###.###/####-##', $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            {{ item.cnpj | cpfCnpj }}
        </template>
        <template v-slot:head(5)="{ item }">
            E-mail <i class="filter" :class="!isEmpty(filtro.email) || filtro.filtrarEmail == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('E-mail', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            {{ item.email }}
        </template>
        <template v-slot:head(6)="{ item }">
            Telefone <i class="filter" :class="!isEmpty(filtro.telefone) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Telefone', 'mascara', '', 'telefone', $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.telefone | telefone }}
        </template>
        <template v-slot:head(7)="{ item }">
            Data Última Atualização <i class="filter" :class="!isEmpty(filtro.atualizacao) || filtro.filtrarAtualizacao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Última Atualização', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(7)="{ item }">
            <p class="text-center">
                {{ item.dataAtualizacao }}
            </p>
        </template>
        <template v-slot:head(8)="{ item }">
            Situação <i class="filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'radio', 'Ativo,Inativo', null, $event)"></i>
        </template>
        <template v-slot:cell(8)="{ item }">
            {{ item.situacao }}
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';

export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codContribuinte)) {
                        this.selecteds.push(el.codContribuinte);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codContribuinte)) {
                        const index = this.selecteds.indexOf(el.codContribuinte);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.codContribuinte);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.codContribuinte);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
